var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAndreas = function SvgAndreas(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 41"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EC0000",
    fillRule: "evenodd",
    d: "m0 37.746 3.52-3.537L0 30.672l2.346-2.358 3.52 3.537 3.518-3.537 2.346 2.358-3.519 3.537 3.52 3.537-2.347 2.357-3.519-3.536-3.519 3.536L0 37.746ZM0 9.431l3.52-3.537L0 2.358 2.346 0l3.52 3.537L9.383 0l2.346 2.358-3.519 3.536 3.52 3.537-2.347 2.358-3.519-3.537-3.519 3.537L0 9.43ZM0 23.6l3.52-3.537L0 16.527l2.346-2.358 3.52 3.537 3.518-3.537 2.346 2.358-3.519 3.537 3.52 3.536-2.347 2.358-3.519-3.537-3.519 3.537L0 23.6Z",
    clipRule: "evenodd"
  })));
};
export default SvgAndreas;